export default "/images/background_image_mask__small.png";